import { useI18n } from '@/hooks/useI18n';
import { useToast } from '@/hooks/useToast';
import { teamMembers } from '../data';

export const TeamGrid = () => {
  const { t } = useI18n();
  const { notify } = useToast();

  return (
    <div className="people-grid">
      {teamMembers.map((member) => (
        <article key={member.id} className="person-card">
          <span className="avatar" aria-hidden="true">
            {member.initials}
          </span>
          <h4>{member.name}</h4>
          <p>{t(member.roleKey)}</p>
          <button type="button" onClick={() => notify(`${t('common.profile')}: ${member.name}`)}>
            {t('common.profile')}
          </button>
        </article>
      ))}
    </div>
  );
};
